import React from 'react';

const CoverLetterSkeleton = () => {
  return (
    <div className="animate-pulse">
      {/* Encabezado */}
      <div className="border-b border-gray-200 pb-6 mb-10">
        <div className="flex justify-between items-start">
          <div className="space-y-3">
            <div className="h-7 bg-gray-300 rounded w-64 mb-2"></div>
            <div className="h-5 bg-gray-200 rounded w-48"></div>
            <div className="space-y-1.5 mt-3">
              <div className="h-4 bg-gray-200 rounded w-40"></div>
              <div className="h-4 bg-gray-200 rounded w-44"></div>
              <div className="h-4 bg-gray-200 rounded w-52"></div>
            </div>
          </div>
          <div className="bg-gray-100 p-2 rounded-lg w-32 h-10"></div>
        </div>
      </div>

      {/* Contenido de la carta */}
      <div className="space-y-6">
        <div className="h-5 bg-gray-300 rounded w-64"></div>

        <div className="space-y-5">
          {/* Párrafos */}
          <div className="h-4 bg-gray-200 rounded w-full"></div>
          <div className="h-4 bg-gray-200 rounded w-full"></div>
          <div className="h-4 bg-gray-200 rounded w-11/12"></div>
          <div className="h-4 bg-gray-200 rounded w-full"></div>
          <div className="h-4 bg-gray-200 rounded w-10/12"></div>
          <div className="h-4 bg-gray-200 rounded w-full"></div>
          <div className="h-4 bg-gray-200 rounded w-full"></div>
          <div className="h-4 bg-gray-200 rounded w-9/12"></div>
          <div className="h-4 bg-gray-200 rounded w-full"></div>
          <div className="h-4 bg-gray-200 rounded w-full"></div>
          <div className="h-4 bg-gray-200 rounded w-11/12"></div>
        </div>

        {/* Firma */}
        <div className="mt-12 pt-6 border-t border-gray-200">
          <div className="h-5 bg-gray-300 rounded w-40 mb-5"></div>
          <div className="bg-gray-100 px-4 py-2 rounded w-48">
            <div className="h-5 bg-gray-300 rounded w-32 mb-1"></div>
            <div className="h-4 bg-gray-200 rounded w-24"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoverLetterSkeleton; 